/*
$(function () {  
  $('#mainNav16 .no-js').removeClass('no-js');
  $('#mainNav16 li.title').click(function(e) {
      $(this).siblings().removeClass('titleactive');
      $(this).toggleClass('titleactive');
      $(this).siblings().find('ul.toggle').fadeOut(200).removeClass('togactive');
      $(this).children().next('ul.toggle').stop(true, false, true).fadeToggle(200).toggleClass('togactive');      
      e.stopPropagation();
    });

   $(document).click(function() {
      $('#mainNav16 .titleactive').removeClass('titleactive');
      $('#mainNav16 .togactive').fadeOut(200).removeClass('togactive');  	
      $('#mainNav16 .no-js').removeClass('no-js');
    });
  
});
*/

/*
$('#mainNav16 ul.navtopul > li.has-children > span').click(function() {
  	$(this).parent().siblings().removeClass('titleactive');
  	$(this).parent().toggleClass('titleactive');
	$(this).parent().siblings().find('ul.toggle').fadeOut(200).removeClass('togactive');
	$(this).next('ul.toggle').stop(true, false, true).fadeToggle(200).toggleClass('togactive');
	return false;
});

$("body").click(function () {  	 	
  	$('#mainNav16 .togactive').stop(true, false, true).fadeOut(200).removeClass('togactive');  
  	$('#mainNav16 li.titleactive').removeClass('titleactive');
});
*/

$(function () {  
  $('#mainNav16 .no-js').removeClass('no-js');
  $('#mainNav16 ul.navtopul > li.has-children > span').click(function(e) {
      $(this).parent().siblings().removeClass('titleactive');
      $(this).parent().toggleClass('titleactive');
      $(this).parent().siblings().find('ul.toggle').fadeOut(200).removeClass('togactive');
      $(this).next('ul.toggle').stop(true, false, true).fadeToggle(200).toggleClass('togactive');    
      e.stopPropagation();
    });

   $(document).click(function() {
      $('#mainNav16 .titleactive').removeClass('titleactive');
      $('#mainNav16 .togactive').fadeOut(200).removeClass('togactive');  	
      $('#mainNav16 .no-js').removeClass('no-js');
    });
  
});

$(function()
{
    var $dropdowns = $('#mainNav16 .togglesecondary'); // Specifying the element is faster for older browsers

    /**
     * Mouse events
     *
     * @description Mimic hoverIntent plugin by waiting for the mouse to 'settle' within the target before triggering
     */
    $dropdowns
        .on('mouseover', function() // Mouseenter (used with .hover()) does not trigger when user enters from outside document window
        {
            var $this = $(this);

            if ($this.prop('hoverTimeout'))
            {
                $this.prop('hoverTimeout', clearTimeout($this.prop('hoverTimeout')));
            }

            $this.prop('hoverIntent', setTimeout(function()
            {
              	$this.addClass('hover');
              	$this.find('.bfade').show("slide", { direction: "left" }, 100);
            }, 250));
        })
        .on('mouseleave', function()
        {
            var $this = $(this);

            if ($this.prop('hoverIntent'))
            {
                $this.prop('hoverIntent', clearTimeout($this.prop('hoverIntent')));
            }

            $this.prop('hoverTimeout', setTimeout(function()
            {   
              	$this.find('.bfade').hide("slide", { direction: "left" }, 70);
             	$this.removeClass('hover');
            }, 250));
        });

    /**
     * Touch events
     *
     * @description Support click to open if we're dealing with a touchscreen
     */
    if ('ontouchstart' in document.documentElement)
    {
        $dropdowns.each(function()
        {
            var $this = $(this);

            this.addEventListener('touchstart', function(e)
            {
                if (e.touches.length === 1)
                {
                    // Prevent touch events within dropdown bubbling down to document
                    e.stopPropagation();

                    // Toggle hover
                    if (!$this.hasClass('hover'))
                    {
                        // Prevent link on first touch
                        if (e.target === this || e.target.parentNode === this)
                        {
                            e.preventDefault();
                        }

                        // Hide other open dropdowns
                        $dropdowns.removeClass('hover');
                        $this.addClass('hover');

                        // Hide dropdown on touch outside
                        document.addEventListener('touchstart', closeDropdown = function(e)
                        {
                            e.stopPropagation();

                            $this.removeClass('hover');
                            document.removeEventListener('touchstart', closeDropdown);
                        });
                    }
                }
            }, false);
        });
    }
    
});